import React from 'react'
import Roll from '../assets/icons/Roll'


function Hourglass({title,message}) {
  return (
    <div
          id="modal"
          // onClick={handleOnClose}
          className="bg-black bg-opacity-20 fixed z-50 inset-0  flex justify-center items-center cursor-wait"
        >
          <div className="bg-white mt-12 p-4 rounded-xl w-4/12 animate-zoom-in">
          <div className=" flex justify-center items-center my-4">
              <Roll/>
          </div>
            <div className=" w-full  text-gray-600">
            <p className=" font-semibold my-3  text-2xl text-center">{title||""}</p>
            <p className="  my-2  text-slate-500  text-xl text-center">{message||""}</p>
            </div>
          </div>
        </div>
  )
}

export default Hourglass